module.exports = __webpack_public_path__ + "static/img/footerlogo.d0289dc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/footerlogo.jpg
// module id = 7NEl
// module chunks = 0